'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.createSimpleFC({
  tag: 'i',
  name: 'icon-spin',
  className: 'icon-spin'
});

exports.default = index;
